import { StatusBar } from '@components/StatusBar'
import { pluralize } from '@util'

export const PageCount = ({ count }: { count?: number }) => (
  <StatusBar.Text>
    {String(count) + pluralize(count ?? 0, ' Page')}
  </StatusBar.Text>
)
